export default __webpack_public_path__ + "static/media/galaxy_interactive.57bb4428.svg";